var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmDownloadViolet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7229 13.7463C17.5921 13.7463 18.4256 13.4003 19.0402 12.7843C19.6547 12.1684 20 11.333 20 10.4619C20 9.59079 19.6547 8.75537 19.0402 8.13942C18.4256 7.52346 17.5921 7.17742 16.7229 7.17742H15.7866C15.9232 6.56741 15.9253 5.9391 15.7927 5.32836C15.6602 4.71762 15.3955 4.13642 15.0139 3.61794C14.6323 3.09946 14.1413 2.65385 13.5688 2.30655C12.9963 1.95925 12.3535 1.71708 11.6773 1.59384C11.001 1.47061 10.3044 1.46873 9.62737 1.58832C8.9503 1.7079 8.30597 1.94661 7.73117 2.29082C6.57031 2.98597 5.76314 4.06861 5.48723 5.30059C4.48908 5.26051 3.50744 5.55434 2.71039 6.13174C1.91334 6.70915 1.35045 7.53422 1.11811 8.4657C0.885762 9.39718 0.998408 10.3771 1.43676 11.2377C1.87511 12.0984 2.6119 12.7861 3.52098 13.1833M10.1688 9.05425V17.5M10.1688 17.5L7.35984 14.6848M10.1688 17.5L12.9777 14.6848",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmDownloadViolet);
export default __webpack_public_path__ + "static/media/crm-download-violet.c1dce9fd6662141bcdc3bad4b089c9c1.svg";
export { ForwardRef as ReactComponent };